<template>
  <el-dialog
    title="批量修改防骚扰平台"
    :visible.sync="disabled"
    @close="close"
    width="700px"
  >
    <el-form :rules="rules" ref="form" :model="form">
      <el-table
        height="400px"
        :data="tableData"
        style="width: 100%"
        :cell-style="cellStyle"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column prop="name" label="企业名称"></el-table-column>
        <el-table-column label="防骚扰平台">
          <template slot-scope="scope">
            {{ scope.row.StormInfo.name || "" }}
          </template>
        </el-table-column>
      </el-table>
      <el-form-item :label="`共选择${tableData.length}个`" prop="num">
      </el-form-item>
      <el-form-item label="防骚扰平台" prop="black_plat_id">
        <el-select
          style="width: 300px"
          v-model="form.black_plat_id"
          placeholder="请选择防骚扰平台"
          filterable
        >
          <el-option
            v-for="item in BlackPlat"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close" :loading="btnLoading">取 消</el-button>
      <el-button
        type="primary"
        @click="onDistribute('form')"
        :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { postCompanyBatchUpdateBlackAction } from "@/services/server/AccountInterface";
import { getData } from "@/api/index";
export default {
  props: {
    isShow: Boolean,
    rowData: Array,
  },
  data() {
    return {
      disabled: this.isShow,
      form: { id: "", black_plat_id: "" },
      tableData: [],
      BlackPlat: [],
      btnLoading: false,
      rules: {
        black_plat_id: [
          { required: true, message: "请选择风控等级", trigger: "blur" },
        ],
      },
    };
  },
  async created() {
    this.getBlackPlat()
    this.tableData = this.rowData;
    for (let i of this.rowData) {
      this.form.id += i.id + ",";
    }
  },
  methods: {
    getBlackPlat(){
      getData("black.BlackPlatController/tableListAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.message);
        this.BlackPlat = res.data;
      });
    },
    close() {
      this.$emit("close");
    },
    async onDistribute() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.btnLoading = true;
        let res = await postCompanyBatchUpdateBlackAction(this.form);
        this.btnLoading = false;
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("批量修改成功");
        this.close();
        this.$parent.esarchang();
      });
    },
    headerCellStyle() {
      return "text-align:center;background-color:#F2f2f2;";
    },
    cellStyle() {
      return "text-align:center;";
    },
  },
};
</script>

<style>
</style>
